import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import warning from "../../assets/icons/warning.png";

class PasswordResetModal extends React.PureComponent {
  constructor(props){
    super(props);
    this.state = {
      email:"",
      errors : {
        email: ''
      }
    }
  }

  handleInputChange = (event) => {
    let errors = {
      email: ''
    }
    this.setState({
      [event.target.id]: event.target.value,
      errors: errors,
    });
  }

  handleResetUserPassword = (error,resetUserPassword) => {
    this.validate();
    if(error === ""){
      resetUserPassword();
    }
  }

  validate = () => {

    let errors = {
      email: 'Email is required'
    }

    if( this.state.email === "" ){
      this.setState({errors:errors})
    }

  }

  handleFocus = () => {
    if(this.state.email === ""){
      const errors = {
        email: ''
      }
      this.setState({errors:errors});
    }
  }

  onClose = (propFunction) => {
    const errors = {
      email: ""  
    }
    this.setState({
      email:"",
      errors : errors
    });
    propFunction();
  }

  render() {
    const {
      passwordResetOpenModal,
      onclose,
      getInputKeyAndValue,
      resetUserPassword,
      openSignInModal,
      error,
      loading,
    } = this.props;

    let warningEmail;

    if(this.state.errors.email !== ""){
      warningEmail = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    return (
      <Modal
        size="lg"
        centered
        className="Login-modal"
        show={passwordResetOpenModal}
        onHide={() => this.onClose(onclose)}
      >
        <div className="text-center"
          style={{
            width:"100%",
            borderBottom:"0.3px solid lightgray",
            margin:"0px",
            paddingTop:"20px",
            paddingBottom:"20px",
          }}
          >
            <span 
              style={{
                width:"100%",
                fontFamily: "CircularStdMedium, Arial, sans-serif",
                fontSize:"16px",
                fontWeight:"bold",
                color:"black",
                textAlign:"center",
                fontStretch: "normal",
                fontStyle: "normal",
                letterSpacing: "normal",
              }}
              >
              Password Reset
            </span>
          </div>
        <button
          onClick={() => this.onClose(openSignInModal)}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          style={{
            position: "absolute",
            zIndex: "9999",
            top:"15px",
            left:"40px",
            width:"31px",
            height:"32px",
            border:"none",
            backgroundColor:"white"
          }}
        >
          <span 
            aria-hidden="true" 
            style={{
              transform: "rotate(135deg)",
              WebkitTransform: "rotate(135deg)",
              border: "solid black",
              borderWidth: "0 3px 3px 0",
              display: "inline-block",
              padding: "5px",
              backgroundColor:"white"
            }}>
          </span>
        </button>
              
        <Modal.Body style={{marginBottom:"-20px"}}>
          <div className="container">
            <div className="row">
              <div className="col">

                <p
                  style={{
                    fontFamily: "OpenSans, Arial, sans-serif",
                    fontSize: "16.5px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "1.38",
                    letterSpacing: "0.08px",
                    textAlign: "left",
                    color: "#484848",
                    marginTop:"-10px",
                  }}
                >
                  Enter the email address associated with your account, and
                  we'll email you a link to reset your password.
                </p>
                
                <div className="form">

                  <div className="floating-label">      
                    <input 
                      id="email"
                      name="email" 
                      type="email" 
                      placeholder="Email"
                      className={this.state.errors.email ? 'errorInput' : null}
                      value={this.state.email}
                      onChange={(e) => {
                        this.handleInputChange(e);
                        getInputKeyAndValue(e);
                      }}
                      onFocus={this.handleFocus}
                      onBlur={e => {
                      }}
                    />
                    <label className={this.state.errors.email ? 'label' : null}>
                      Email
                    </label>
                  </div>
                  <div className="error">{warningEmail}{this.state.errors.email}</div>

                </div>

                <button
                  type="button"
                  className="btn-lg-block login-btn mb-3"
                  onClick={() => this.handleResetUserPassword(error,resetUserPassword)}
                  style={{ 
                    height: "57px",
                    padding: "18px",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "bold",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "1.25",
                    letterSpacing: "0.08px",
                    textAlign: "center",
                    color: "#ffffff",
                  }}
                >
                  {loading ? (
                    <span
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Spinner
                        animation="border"
                        style={{ width: "25px", height: "25px" }}
                      />
                    </span>
                  ) : (
                    "Send reset link"
                  )}
                </button>
              
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default PasswordResetModal;
